import { CLIENT_CONTACT_TYPES } from '../constants';
import type { ContactType } from '../types';

export const isClientContactType = (type: ContactType) =>
  CLIENT_CONTACT_TYPES.includes(type);
